import React from 'react';
import CardProject from '../../components/Client/dashboardComponents/CardProject';
import HeaderDashboard from '../../components/Client/dashboardComponents/HeaderDashboard';
// import { BsEmojiDizzyFill } from 'react-icons/bs';
import { CiCirclePlus } from 'react-icons/ci';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DashboardPageActor from '../../components/acteurs/DashboardPageActor';
import MonBouton from '../../components/Utils/design-system/buttons/MonBouton';
import { selectData } from '../../redux/features/userSliceWithTokenValidation';

function DashboardClientPage() {
  const user = useSelector(selectData);
  const navigate = useNavigate();
  return (
    <div className='grid gap-8 px-5 pt-6'>
      {user?.statut === "client" ? <div className=''>
        <HeaderDashboard />
        <div>
          <div className='flex justify-between items-center'>
            <p className='font-inter text-lg text-noir_300 pt-2'>La liste de mes projets</p>
            <div className='px-2'>
              <MonBouton children={"Ajouter un projet"} couleurFond={"bg-white"} bordure={"border px-2 py-2 justify-center rounded-full text-xs"} icone={<CiCirclePlus />} action={() => navigate("ajout-projet")} type={"button"} />
            </div>
          </div>
        </div>
        <CardProject />
      </div> : <div className=''>
        <DashboardPageActor />
      </div>}
    </div>
  )
}

export default DashboardClientPage